import React from "react";

class PageHeader extends React.Component {
    render() {
        const { HeaderText } = this.props;
        return (
            <div className="block-header card">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-md-6 col-sm-12">
                        <h2>{HeaderText}</h2>
                        {/* <ul className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a href="dashboard">
                                    <i className="icon-home"></i>
                                </a>
                            </li>
                            {Breadcrumb.map((item, index) => {
                                return (
                                    <li
                                        key={item.name + index}
                                        className="breadcrumb-item active"
                                    >
                                        <a href={item.navigate ? item.navigate : null}>
                                            {item.name}
                                        </a>
                                    </li>
                                );
                            })}
                        </ul> */}
                    </div>

                    {/* Un-comment the below code to see the two graph */}


                    {/* <div className="col-lg-7 col-md-4 col-sm-12 text-right"> */}
                    {/* <div className="inlineblock text-center m-r-15 m-l-15 hidden-sm"> */}
                    {/* <div
                id="visitorsSparcalChart"
                className="sparkline text-left"
                // change width to some value to see the graph
                style={{ width: "0vh", height: 25 }}
              ></div> */}
                    {/* <span>Visitors</span> */}
                    {/* </div> */}
                    {/* <div className="inlineblock text-center m-r-15 m-l-15 hidden-sm"> */}
                    {/* <div
                id="visitsSparcalChart"
                className="sparkline text-left"
                // change width to some value to see the graph
                style={{ width: "0vh", height: 25 }}
              ></div> */}
                    {/* <span>Visits</span> */}
                    {/* </div> */}
                    {/* </div> */}
                </div>
            </div>
        );
    }
}

export default PageHeader;
